module.exports = __webpack_public_path__ + "static/media/zip-water.b03f8b04.png";